export const CHALLENGES_ENABLED = true;
export const AREAS_OF_IMPROVEMENT_ENABLED = false;
export const TALENT_ORGANIZER_ENABLED = true;
export const SPLASH_NOTIFICATIONS_ENABLED = true;
export const TALENT_CONNECTOR_ENABLED = true;
export const RANKINGS_NAVIGATION_ENABLED = false;
export const RATINGS_AND_REVIEWS_ENABLED = false;
export const KING_OF_DRAG_ENABLED = false;
